MLCV.AutoComplete = { // eslint-disable-line no-undef
    AttachEventHandlers: function () {
        /* MEGA MENU SEARCH */

        $.widget("custom.catcompletepeopleMenu", $.ui.autocomplete, {
            _renderMenu: function (ul, items) {
                const that = this;
                $.each(items, function (index, item) {
                    item.label = item.DisplayName;
                    item.value = item.DisplayName;
                    that._renderItemData(ul, item);
                });
            }
        });

        jQuery('#people-search2').autoSuggestMenu({
            listUrl: "/api/custom/biolisting/getautosuggestresult"
        });

        $.widget("custom.catcompleteGroupMenu", $.ui.autocomplete, {
            _create: function () {
                this._super();
                this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
            },
            _renderMenu: function (ul, items) {
                const that = this;
                let currentCategory = "";
                $.each(items, function (index, item) {
                    if (item.FilterGroupName != currentCategory) {
                        ul.append("<li class='ui-autocomplete-category'>" + item.FilterGroupName + "</li>");
                        currentCategory = item.FilterGroupName;
                    }

                    item.label = item.FilterName;
                    item.value = item.FilterName;
                    const li = that._renderItemData(ul, item);
                    if (item.FilterGroupName) {
                        li.attr("aria-label", item.FilterGroupName + " : " + item.FilterName);
                    }
                });
            }
        });

        $.widget("custom.completelistMenu", $.ui.autocomplete, {
            _renderItem: function (ul, item) {
                return jQuery("<li>")
                    .append("<a>" + item.FilterName + "</a>")
                    .appendTo(ul);
            }
        });

        jQuery('#sector-search2').autoSuggestMenu({
            listUrl: "/api/custom/commonfilterlisting/getssrlist",
            listType: "catcompleteGroupMenu"
        });

        /* GLOBAL SEARCH */

        $.widget("custom.catcompleteGlobalSearch", $.ui.autocomplete, {
            _renderMenu: function (ul, items) {
                const that = this;
                ul.addClass("autocomplete-width");
                if (jQuery(".global-header-container.sticky").length > 0) {
                    ul.css("position", "fixed");
                }
                else {
                    ul.css("position", "absolute");
                }
                $.each(items, function (index, item) {
                    if (item.IsResultsGroup) {
                        ul.append("<li class='ui-autocomplete-category'>" + decodeURIComponent(item.Title) + "</li>");
                    }
                    item.label = item.Title;
                    item.value = item.Title;
                    if (!item.IsResultsGroup) {
                        that._renderItemData(ul, item);
                    }
                    else if (item.IsGroupLastElement) {
                        that._renderItemData(ul, item);
                    }
                });
            },
        });

        jQuery('#txtSiteSearch').globalAutoSuggest({
            itemId: ""
        });

        /* ALUMNI SEARCH */
        jQuery('.alumni-search-text').autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: '../../api/custom/commonfilterlisting/getschoollist',
                    data: { term: request.term },
                    type: 'Get',
                    dataType: "json",

                    success: function (data) {
                        response($.map(data, function (item) {
                            return {
                                value: item.FilterName,
                                name: item.FilterName,
                                label: item.FilterName
                            }
                        }));
                    }
                })
            },
            select: function (event, ui) {
                jQuery(this).val(ui.item.name);
                return false;
            },
            minLength: 2,
            create: function (event, ui) { // eslint-disable-line no-unused-vars
                const autoComplete = jQuery(this).autocomplete("widget");
                autoComplete.css("z-index", "5554");
                autoComplete.insertAfter(jQuery(this));
            }
        });

        // Close Auto-Suggest upon clicking anywhere
        jQuery("a, button").click(function (event) {
            const autoSuggest = ".ui-autocomplete:visible";
            if (!jQuery(event.target).closest(autoSuggest).length &&
                !jQuery(event.target).is(autoSuggest)) {
                jQuery(autoSuggest).hide();
            }
        });
    }
}

jQuery(document).ready(function () {
    MLCV.AutoComplete.AttachEventHandlers(); // eslint-disable-line no-undef
});